<div class="container-fluid background-image pl-0 pr-0">
    <div class="row justify-content-center align-items-center mr-0" style="height:92vh">
        <div class="col-auto">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>